import reducer from "./reducers";

import * as ventasCitasOps from "./operations";
import * as ventasCitasTypes from "./types";

export { ventasCitasOps, ventasCitasTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventasCitas/index.js